import React from 'react';

export const Tabla = ({ cols, rows, testid }) => (
  <div className="max-h-56 overflow-auto border border-slate-200 rounded" data-testid={testid}>
    <table className="w-full text-xs">
      <thead className="bg-slate-50 sticky top-0">
        <tr>{cols.map(([, label]) => <th key={label} className="text-left px-2 py-1 font-medium text-slate-600">{label}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className="border-t border-slate-100">
            {cols.map(([fn, label]) => <td key={label} className="px-2 py-1 text-slate-700">{fn(r)}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Kpis = ({ defs, r, prefijo }) => (
  <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
    {defs.filter(([k]) => r[k] !== undefined).map(([k, label]) => (
      <div key={k} className="border border-slate-200 rounded p-2" data-testid={`${prefijo}-kpi-${k}`}>
        <p className="text-[11px] text-slate-500 leading-tight">{label}</p>
        <p className="text-lg font-semibold text-slate-900">{Number(r[k]).toLocaleString('es-AR')}</p>
      </div>
    ))}
  </div>
);

export const fechaAR = (v) => (v ? new Date(v).toLocaleDateString('es-AR') : '—');
